import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const InputText = (props) => {
  return (
    <FormGroup>
      <Label for={props.id}>{props.label}</Label>
      <Input
        id={props.id}
        name={props.name}
        type={props.type}
        value={props.value}
        placeholder={props.placeholder}
        onChange={props.onChange}
        readOnly={props.readOnly}
        className={`${props.error ? "is-invalid" : ""}`}
      />
      <div className="invalid-feedback">{props.error}</div>
    </FormGroup>
  );
};

export default InputText;
